import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function ProductManagerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["product-manager"]} />;
}
